import actions from '../actions/user';
import mutations from '../mutations/user';
import getters from '../getters/user';
import SiteEnv from '../utils/siteEnv';

const siteBase = SiteEnv.showSiteBase();

const state = {
    errorMessage: '',
    successMessage: '',
    userInfo: {
        countFans: null,
        createDate: 0,
        headUrl: undefined,
        id: undefined,
        memberNo: undefined,
        nick: undefined,
        phone: null,
        retailAgent: false,
        sex: 0,
        sign: undefined,
        teamAgent: false,
        updateDate: 0,
        wxQrcodeCardUrl: null
    },
    idolInfo: {
        countFans: null,
        createDate: 0,
        headUrl: undefined,
        id: undefined,
        memberNo: undefined,
        nick: undefined,
        phone: null,
        retailAgent: false,
        sex: 0,
        sign: undefined,
        teamAgent: false,
        updateDate: 0,
        wxQrcodeCardUrl: null
    },
    property: {
        balance: 0,
        blocking: 0,
        usable: 0,
        total: 0
    },
    score: {
        indirect: 0,
        direct: 0,
        total: 0
    },
    profit: {
        retail: 0,
        team: 0
    },
    nexus: {
        desc: 'retail.son:零售子节点数\nretail.sons:零售子子孙孙节点数\nteam.son:团队模式子节点数\nteam.sons:团队模式子子孙孙节点数\ncountFans:用户的粉丝数',
        retail: {
            sons: 0,
            son: 0
        },
        team: {
            sons: 0,
            son: 0
        },
        countFans: 0
    },
    incomeRetail: {
        list: [],
        user: []
    },
    incomeTotalRetail: 0,
    incomeTeam: {
        list: [],
        user: []
    },
    passwd: '',
    openid: '',
    incomeTotalTeam: 0,
    withDrawList: [],
    // state分两个，vue监听不到深层变化
    nexusRetailLevelOverview: [],
    nexusRetailLevelUsers: [],
    // Team
    nexusTeamLevelOverview: [],
    nexusTeamLevelUsers: [],
    // 粉丝列表
    fansList: {
        fans: [],
        users: []
    },
    // 最新排名
    topProfit: {
        list: [],
        users: []
    },
    // 收款二维码
    qrocodes: [],
    // 渠道信息总览
    channel: {
        axis: [],
        value: []
    },
    // 渠道信息
    channelList: {
        list: [],
        overviews: []
    },
    // 用户余额
    userProfit: {
        createDate: 1532710311000,
        frozenMoney: 4000,
        frozenScore: 0,
        id: 2,
        surplusMoney: 9072,
        surplusScore: 0,
        updateDate: 1533519072000,
        userId: 436
    },
    friendEnvPoster: [
        {
            templateTitle: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201807/18/20180718181653491741919.png?x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8xOC8yMDE4MDcxODE4MjE0OTU2NjA2NDg3MS5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8yMA,t_100,g_nw,x_200,y_400,x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8yOS8yMDE4MDcyOTE3MTgyMzIwMTM1Mzk3My5qcGc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xNg,t_100,g_nw,x_1000,y_710,x-oss-process=image/watermark,size_80,text_5byg5LiJMzM,t_100,g_nw,x_610,y_510,x-oss-process=image/watermark,size_80,text_6auY57qn5Lya5ZGY,t_100,g_nw,x_610,y_710',
            template: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201807/18/20180718181653491741919.png?x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8xOC8yMDE4MDcxODE4MjE0OTU2NjA2NDg3MS5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8yMA,t_100,g_nw,x_200,y_400,x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8yOS8yMDE4MDcyOTE3MTgyMzIwMTM1Mzk3My5qcGc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xNg,t_100,g_nw,x_1000,y_710,x-oss-process=image/watermark,size_80,text_5byg5LiJMzM,t_100,g_nw,x_610,y_510,x-oss-process=image/watermark,size_80,text_6auY57qn5Lya5ZGY,t_100,g_nw,x_610,y_710',
            poster: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201807/18/20180718181653491741919.png?x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwOC8wNC8yMDE4MDgwNDEzMzQ1ODc2NDE4NTk4My5wbmc=,t_100,g_nw,x_200,y_400,x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwOC8wNC8yMDE4MDgwNDEzMzQ1ODc2NDE4NTk4My5wbmc=,t_100,g_nw,x_1000,y_710,x-oss-process=image/watermark,size_80,text_bmV3MjEx,t_100,g_nw,x_610,y_510,x-oss-process=image/watermark,size_80,text_6auY57qn5Lya5ZGYZGY,t_100,g_nw,x_610,y_710'
        }
    ],
    friendPoster: [
        {
            templateTitle: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201807/18/20180718181653491741919.png?x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8xOC8yMDE4MDcxODE4MjE0OTU2NjA2NDg3MS5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8yMA,t_100,g_nw,x_200,y_400,x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8yOS8yMDE4MDcyOTE3MTgyMzIwMTM1Mzk3My5qcGc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xNg,t_100,g_nw,x_1000,y_710,x-oss-process=image/watermark,size_80,text_5byg5LiJMzM,t_100,g_nw,x_610,y_510,x-oss-process=image/watermark,size_80,text_6auY57qn5Lya5ZGY,t_100,g_nw,x_610,y_710',
            template: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201807/18/20180718181653491741919.png?x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8xOC8yMDE4MDcxODE4MjE0OTU2NjA2NDg3MS5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8yMA,t_100,g_nw,x_200,y_400,x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwNy8yOS8yMDE4MDcyOTE3MTgyMzIwMTM1Mzk3My5qcGc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xNg,t_100,g_nw,x_1000,y_710,x-oss-process=image/watermark,size_80,text_5byg5LiJMzM,t_100,g_nw,x_610,y_510,x-oss-process=image/watermark,size_80,text_6auY57qn5Lya5ZGY,t_100,g_nw,x_610,y_710',
            poster: 'http://aqukedev.oss-cn-shanghai.aliyuncs.com/file/1/201807/18/20180718181653491741919.png?x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwOC8wNC8yMDE4MDgwNDEzMzQ1ODc2NDE4NTk4My5wbmc=,t_100,g_nw,x_200,y_400,x-oss-process=image/watermark,image_ZmlsZS8xLzIwMTgwOC8wNC8yMDE4MDgwNDEzMzQ1ODc2NDE4NTk4My5wbmc=,t_100,g_nw,x_1000,y_710,x-oss-process=image/watermark,size_80,text_bmV3MjEx,t_100,g_nw,x_610,y_510,x-oss-process=image/watermark,size_80,text_6auY57qn5Lya5ZGYZGY,t_100,g_nw,x_610,y_710'
        }
    ],
    ownRank: {
        overRanking: 999
    },
    fans: {
        value: [],
        asis: []
    },
    fansSummary: {
        all: 0,
        day: 0,
        week: 0,
        month: 0
    },
    loginConfig: siteBase,
    getLoginCode: false,
    login: false,
    rightCode: true,
    memberLevelList: [], //会员等级
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/user.js